function hasKeys(value) {
  return value && typeof value === 'object' && Object.keys(value).length > 0;
}

export function mergeExplanationWidgetFilters(widgetFilters, selectionFilters = []) {
  const base = widgetFilters && typeof widgetFilters === 'object' ? widgetFilters : {};
  const filters = [
    ...(Array.isArray(base.filters) ? base.filters : []),
    ...(Array.isArray(selectionFilters) ? selectionFilters : []),
  ];
  const merged = { ...base };
  if (filters.length) merged.filters = filters;
  else delete merged.filters;
  return merged;
}

export function buildWidgetExplanationRequest({
  filterSessionId,
  globalFilters,
  widgetFilters,
  selectionFilters,
  selection,
  selectedScope = false,
  sourceSearch,
} = {}) {
  const request = {};
  if (filterSessionId) request.filterSessionId = filterSessionId;
  if (hasKeys(globalFilters)) request.globalFilters = globalFilters;

  if (hasKeys(widgetFilters)) request.widgetFilters = { ...widgetFilters };
  if (Array.isArray(selectionFilters) && selectionFilters.length) {
    request.selectionFilters = [...selectionFilters];
  }

  const selectedValues = Array.isArray(selection?.values)
    ? selection.values
      .filter(item => item && Object.prototype.hasOwnProperty.call(item, 'value'))
      .map(item => item.value)
    : [];
  if (selectedScope && selection?.filterColumn && selectedValues.length) {
    request.selectedGroups = [{ column: selection.filterColumn, values: selectedValues }];
  } else if (!selectedScope && selection?.filterColumn && selectedValues.length) {
    request.selfSelectionExcludedGroups = [selection.filterColumn];
  }

  const normalizedSourceSearch = typeof sourceSearch === 'string' ? sourceSearch.trim() : '';
  if (normalizedSourceSearch) request.sourceSearch = normalizedSourceSearch;
  return request;
}

export function createExplanationRequestCoordinator() {
  let sequence = 0;
  let controller = null;
  return {
    begin() {
      if (controller) controller.abort();
      controller = new AbortController();
      sequence += 1;
      return { token: sequence, signal: controller.signal };
    },
    isCurrent(token) {
      return token === sequence && !!controller && !controller.signal.aborted;
    },
    cancel() {
      if (controller) controller.abort();
      controller = null;
      sequence += 1;
    },
  };
}
